export class MapViewState {
    mode: MapViewMode = MapViewMode.BROWSE
}

export enum MapViewMode {
    BROWSE,
    EDIT,
    LINES,
    TOPO,
    EXPORT,
    LAYERS,
}